import React from 'react';
import { useNavigate } from "react-router-dom";
import home from '../images/home.png';
import { ITEMS } from './Items';


const Home = () => {

    let navigate = useNavigate();

    const handleAuth = (type) => {
        if (type == "endUser") {
            navigate("/ocr", { state: { type } });
        }
        else {
            navigate("/adminPage", { state: { type } });
        }
    };

    return (
        <>
            <div className='md:flex'>
                <img src={home} alt="writing" className='w-screen h-[27vh] object-cover md:w-[60vw] md:h-[100vh]' />

                <div>
                    <div className="font-bold text-2xl pt-4 pb-6 md:pt-20 md:pb-16 md:px-[15vw] text-center">
                        Welcome to
                        <div className='playwrite text-green-600 text-4xl'>PiScanner</div>
                    </div>

                    <div className='px-10 md:px-14'>
                        <ul className='pb-12 list-disc space-y-2 text-sm text-justify'>
                            {ITEMS.map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>

                        <div className='flex flex-col items-center space-y-2'>
                            <button
                                onClick={() => handleAuth("admin")}
                                className="button-style px-13"
                            >Use as an Admin</button>

                            <p className='text-xs'>or</p>

                            <button
                                onClick={() => handleAuth("endUser")}
                                className="button-style px-12"
                            >Use as an End User</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Home